import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const ApiKeyUpdateForm = React.lazy(() => loadComponent('api_gateway', 'ApiKeyUpdateForm'))

export function ApiKeyDetailsRoute() {
    const params = useParams()
    const navigate = useNavigate()

    const canUpdate = usePermission('apigateway.apikey.update', {})
    const canDelete = usePermission('apigateway.apikey.delete', {})

    const onDelete = useCallback(() => {
        navigate('/settings/apikeys')
    }, [navigate])

    return (
        <RouteContainer>
            <ApiKeyUpdateForm _id={params._id} canDelete={canDelete} canUpdate={canUpdate} onDelete={onDelete} />
        </RouteContainer>
    )
}
